module.exports = __webpack_public_path__ + "static/img/AE@2x.f0f60c51.jpg";